import React from "react";
import "./jobItem.scss";
import { judgePlatformc,GetQueryString, setMLog} from "../../env/fun.js";
import fetchJsonp from 'fetch-jsonp';
let plat = judgePlatformc();

export default class JobItem extends React.Component {
  state = {
    isApply: this.props.isApply,
    request:this.props.request,
    displayPosition: GetQueryString("displayPosition"),
  };

  componentWillReceiveProps(props) {
    this.setState({
      isApply: props.isApply
    })
  }


  changeImg = (e) => {
    e.target.onerror = null;
    e.target.src = "https://pic1.58cdn.com.cn/nowater/cxnomark/n_v2bd7f0988e44d40b9adbb331d8ccedf7a.png"
  }

  //职位详情页
  qyDetail = (action,item) => {
    console.log(item, 'item');
    if (item.chargeUrl) {
      fetchJsonp(item.chargeUrl);
    }
    setMLog(`zpbrainrec_2021magical_guess_details&tjfrom=${item.tjfrom}&infoid=${item.infoID}`);
    if (plat === "app") {
      window.WBAPP && window.WBAPP.invoke('pagetrans', JSON.parse(action))
    } else{
      window.location.href = action;
    }
  };

  //简历投递
  delivery = (e, item) => {
    
    e.nativeEvent.stopImmediatePropagation();
    e.stopPropagation();
    const { infoID, finalCp, tjfrom,isApply,chargeUrl} = item;
    if (this.state.isApply === "1") return;
    const self = this;
    let params = {
      infoId: infoID,
      sourceId: plat === "app" ? "78" : "79",
      tjFrom: tjfrom,
      finalCp: finalCp,
      deliverySource:'110',
      deliveryCallBackFn: function () {
        self.setState({
          isApply: "1",
        });
        // self.state.request();
      },
      failCallBackFn: function () {
        console.log("false");
      },
    };
    setMLog(`tjapplyclick_2021magica_guess_apply&tjfrom=${item.tjfrom}&infoid=${item.infoID}`);
    window.delivery_new(params);
    console.log("投递简历")
  };

  render() {
    let {
      action,
      cate,
      hrName,
      hrPhoto,
      recReason,
      quyu,
      qyname,
      title,
      welfare,
      xinzi,
      position,
    } = this.props.item;
    return (
      <li
        className="JobItem"
        onClick={() => {
          this.qyDetail(action,this.props.item);
        }}
      >
        <div className="left">
          <div className="name">{title}</div>
          <div className="title">
            <div className="salary">{xinzi}</div>
            <div>·</div>
            <div className="post">{cate}</div>
          </div>
            <div className="welfare">
              {welfare.map((item, index) => {
                  return (
                    <div className="welfare_item" key={index}>
                      {item}
                    </div>
                  );
              })}
            </div>
          <div className="contacts">
            <img className="img" src={hrPhoto?hrPhoto:require("../../assets/img/userImage.png")} alt=""  onError={(e) => this.changeImg(e)}></img>
            <div className="contacts_information">
              <div className="contacts_name_job">
                <div className="contacts_name">{hrName}</div>
                <div style={{ display: position === "" ? "none" : "block" }}>
                  ·
                </div>
                <div className="contacts_job">{position}</div>
              </div>
              <div className="contacts_qy">
                <div className="qyname">{qyname}</div>
              </div>
            </div>
          </div>
          {/* <div className="evaluate" style={{display:recReason===""?"none":"block"}}>
            <div className="evaluate_box">
              <img className="evaluators_logo" alt="" src={require("../../assets/img/evaluators_logo.png")} ></img>
              <div className="evaluators">{recReason}</div>
            </div>
          </div> */}
        </div>
        <div className="right">
          <div className="address">{quyu}</div>
          <button
            className={this.state.isApply === "1" ? "apply applied" : "apply"}
            onClick={(e) => this.delivery(e, this.props.item)}
          >
            {this.state.isApply === "1" ? "已申请" : "申请"}
          </button>
          <div className="buwei"></div>
        </div>
      </li>
    );
  }
}
